import React, { useEffect, useState } from 'react';
import { aoMudarSessao, sessao } from './api';
import { ToastProvider } from './components/Base';
import Layout from './components/Layout';
import Login from './pages/Login';
import Painel from './pages/Painel';
import Empresas from './pages/Empresas';
import Planos from './pages/Planos';
import Admins from './pages/Admins';
import Logs from './pages/Logs';

function useRota() {
  const [rota, setRota] = useState(window.location.hash || '#/painel');
  useEffect(() => {
    const f = () => setRota(window.location.hash || '#/painel');
    window.addEventListener('hashchange', f);
    return () => window.removeEventListener('hashchange', f);
  }, []);
  return rota;
}

function useSessao() {
  const [s, setS] = useState(sessao());
  useEffect(() => aoMudarSessao(setS), []);
  return s;
}

export default function App() {
  const rota = useRota();
  const s = useSessao();
  const caminho = rota.split('?')[0];
  const logado = !!(s && s.token);

  useEffect(() => {
    if (!logado && caminho !== '#/login') window.location.hash = '#/login';
    if (logado && caminho === '#/login') window.location.hash = '#/painel';
  }, [logado, caminho]);

  if (!logado) return <ToastProvider><Login /></ToastProvider>;

  let titulo = 'Painel';
  let pagina = <Painel />;
  const mEmpresa = caminho.match(/^#\/empresas(?:\/(\d+|nova))?$/);
  if (mEmpresa) { titulo = 'Empresas'; pagina = <Empresas idAberto={mEmpresa[1] || null} />; }
  else if (caminho === '#/planos') { titulo = 'Planos'; pagina = <Planos />; }
  else if (caminho === '#/admins') { titulo = 'Administradores'; pagina = <Admins />; }
  else if (caminho === '#/logs') { titulo = 'Histórico de ações'; pagina = <Logs />; }
  else if (caminho !== '#/painel' && caminho !== '#/login') { window.location.hash = '#/painel'; }

  return (
    <ToastProvider>
      <Layout rota={caminho} titulo={titulo}>{pagina}</Layout>
    </ToastProvider>
  );
}
